export const getPointInLineBounded = (line, x) => {
  if (x > line[1].x) {
    return line[1];
  }
  if (x < line[0].x) {
    return line[0];
  }
  return getPointInLine(line, x);
};

const getPointInLine = (line, x) => {
  const diffX = x - line[0].x;
  const gradient = (line[0].y - line[1].y) / (line[0].x - line[1].x);
  return { x, y: line[0].y + (diffX * gradient) };
};

export const linearRegression = (points) => {
  const pairsAmount = points.length;
  const sum = points.reduce((acc, pair) => ({
    x: acc.x + pair.x,
    y: acc.y + pair.y,
  }), { x: 0, y: 0 });

  const average = {
    x: sum.x / pairsAmount,
    y: sum.y / pairsAmount,
  };

  const SSxx = points.reduce((acc, pair) => parseFloat(acc + (average.x - pair.x) ** 2), 0);
  const SSxy = points.reduce((acc, pair) => parseFloat(acc + ((average.x - pair.x) * (average.y - pair.y))), 0);

  const slope = SSxx !== 0 ? (SSxy / SSxx) : 0;

  const intercept = average.y - (slope * average.x);

  return { slope, intercept };
};
